module.exports = __webpack_public_path__ + "img/logo_fs.f96d435b.svg";